import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import { Box, Tooltip, Typography } from "@mui/material";

import { PersonalizedEmailForContactType } from "@interfaces/campaign.type";

import CampaignContact from "../CampaignContact";
import EmailLayoutStyles from "../EmailLayoutStyles";

export interface IPersonalizeCampaignEmailsProperties {
  campaignEmails: PersonalizedEmailForContactType[];
  removeEmail: (emailId: number) => Promise<void>;
  selectedEmailIndex: number;
  setSelectedEmailIndex: (index: number) => void;
}

export default function EmailList({
  campaignEmails,
  removeEmail,
  selectedEmailIndex,
  setSelectedEmailIndex,
}: IPersonalizeCampaignEmailsProperties) {
  return (
    <Box
      sx={{
        ...EmailLayoutStyles.drawerRoot,
      }}
    >
      <Box
        sx={{
          ...EmailLayoutStyles.drawerHeading,
        }}
      >
        <Typography component="div" variant="h6">
          Select contact to personalize email.
        </Typography>
        <Tooltip title="EditReviewAndTest details and personalize emails for each recipient before sending.">
          <HelpRoundedIcon color="info" sx={{ cursor: "help", height: 16, width: 16 }} />
        </Tooltip>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          maxHeight: "100%",
          overflowY: "scroll",
        }}
      >
        {campaignEmails.map((email, index) => (
          <CampaignContact
            email={email}
            emailId={email.id}
            isBanded={index % 2 === 1}
            isNonInteractive={false}
            isSelected={index === selectedEmailIndex}
            key={email.id}
            removeEmail={removeEmail}
            setSelectedEmail={() => {
              setSelectedEmailIndex(index);
            }}
            showActions={true}
          />
        ))}
      </Box>
    </Box>
  );
}
